import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { ActionButtons } from '../others/ActionButtons';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            redirectHome: false,
            resetKey: 0,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error atrapado por ErrorBoundary:', error, errorInfo);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.locationKey !== this.props.locationKey) {
            this.setState({
                hasError: false,
                error: null,
                redirectHome: false,
                resetKey: this.state.resetKey + 1,
            });
        }
    }

    handleReset = () => {
        const { navigate } = this.props;

        this.setState(
            prev => ({
                hasError: false,
                error: null,
                resetKey: prev.resetKey + 1,
            }),
            () => {
                // Fuerza navegación a la misma ruta para remount completo
                navigate(0); // Equivale a recargar la misma ruta sin refrescar toda la página
            }
        );
    };

    handleRedirectHome = () => {
        this.setState({ redirectHome: true });
    };

    render() {
        const { t } = this.props;

        if (this.state.redirectHome) {
            return <Navigate to="/home" replace />;
        }

        if (this.state.hasError) {
            return (
                <Box sx={{ textAlign: 'center', p: 4 }}>
                    <Typography variant="h4" gutterBottom>
                        {t('common.unexpectedError')}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {t('common.sectionLoadError')}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        {t('common.contactSupport')}{' '}
                        <a href="mailto:soporte@aiautomation.email">soporte@aiautomation.email</a>
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                        <ActionButtons
                            onCancel={this.handleReset}
                            onSubmit={this.handleRedirectHome}
                            cancelLabel={t('common.retry')}
                            submitLabel={t('common.goHome')}
                        />
                    </Box>
                </Box>
            );
        }

        return (
            <React.Fragment key={this.state.resetKey}>
                {this.props.children}
            </React.Fragment>
        );
    }
}

export default withTranslation()(ErrorBoundary);
